module.exports = __webpack_public_path__ + "img/frozen.579b30b3.png";